$( document ).ready(function() {
  

	$('.slider-video').slick({
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows:false,
		dots:false,
		responsive: [ 
		  {
			breakpoint: 991,
			settings: {
			  slidesToShow: 1,
			  slidesToScroll: 1    
			}
		  },
		  {
			breakpoint: 768,
			settings: {
			  slidesToShow: 1,
			  slidesToScroll: 1    
			}
		  }     
		]
	  });   
	
	$(".video-container").each(function() {
	  // Video
	  var $video_container = $(this);
	  var $video = $(this).find("video");
	
	  // Video Controls
	  var $video_controls = $(this).find(".video-inner-container");
	   var $play_button = $(this).find(".play-gif");
	
	  function playVideo(){
		if ($video[0].paused){
		  $video[0].play();
		  $video_controls.addClass("playing");
		} else {
		  $video[0].pause();
		  $video_controls.removeClass("playing"); 
		}
	  }
	
	  // Play/pause on button click
	  $play_button.click(function() {
		playVideo();
	  });
	
	});
	
	var vids = $(".video-container video"); 
	$.each(vids, function(){
		   this.controls = false; 
	}); 
	
	$(document).on("click",".pro-stamped-badge",function() {
	  $('html,body').animate({scrollTop: $("#stamped-main-widget").offset().top},1000);
	});
	  
	// $(".pro-vid-img-section .vid_img_btn .btn").on("click",function(event){
	//     $('html,body').animate({scrollTop: $("product-form.product-form").offset().top - 500},2000);  
	//   });  
	
	

	  });   
	